import { render, staticRenderFns } from "./productList.vue?vue&type=template&id=ffba7f28&"
import script from "./productList.vue?vue&type=script&lang=js&"
export * from "./productList.vue?vue&type=script&lang=js&"
import style0 from "./productList.vue?vue&type=style&index=0&id=ffba7f28&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports